import { useContext, useState } from "react";
import { Tooltip } from "antd";

import { DatastoreContext } from "contexts/datastores/datastores";
import { StyledLabel } from "./styles";

interface InstanceLabelProps {
  category: string;
  name: string;
}

const InstanceLabel = ({ name, category }: InstanceLabelProps) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const { setInstance } = useContext(DatastoreContext);
  if (!setInstance) return null;

  const onClick = () => {
    setInstance({ name, type: category, visible: true });
  };
  return (
    <Tooltip title={name} open={tooltipOpen} placement="right" color="black">
      <StyledLabel
        onMouseEnter={() => setTooltipOpen(true)}
        onMouseLeave={() => setTooltipOpen(false)}
        className="overflow-hidden text-ellipsis"
        onClick={onClick}>
        {name}
      </StyledLabel>
    </Tooltip>
  );
};

export default InstanceLabel;
